import PropTypes from 'prop-types';
import Modal from 'react-modal';

import Link from 'components/hf/HFLink';
import css from 'styles/components/hf/signUpModal.scss';

const SignUpModal = ({ data, setSignUpModal, isSignUpModalOpen, handleSignUpModalSubmit }, { testId }) => {
  if (data && data.componentName === 'melodySignUpModal') {
    const { rewardsheading, cta, emailheading, heading, emailcopy, rewardscopy, subheading } = data;
    return (
      <Modal
        isOpen={isSignUpModalOpen}
        data-test-id={testId('headerFooterSignUpModal')}
        contentLabel="Email Subscriptions"
        onRequestClose={() => setSignUpModal(false)}
        overlayClassName={css.overlay}
        ariaHideApp={false}
        className={css.container}>
        <form method="post" className={css.mSignUpModal} onSubmit={handleSignUpModalSubmit}>
          <button
            type="button"
            title="Close modal"
            onClick={() => setSignUpModal(false)}
            className={css.close}/>
          {heading && <p className={css.heading}>{heading}</p>}
          {subheading && <p className={css.subheading}>{subheading}</p>}
          {(emailheading || emailcopy) &&
            <div className={css.checkboxSection}>
              <input
                type="checkbox"
                id="signupmodalemail"
                name="email"
                defaultChecked={true}/>
              <label htmlFor="signupmodalemail">
                {emailheading && <p className={css.contentHeading}>{emailheading}</p>}
                {emailcopy && <p className={css.contentCopy}>{emailcopy}</p>}
              </label>
            </div>
          }
          {(rewardsheading || rewardscopy) &&
            <div className={css.checkboxSection}>
              <input type="checkbox" id="signupmodalrewards" name="rewards"/>
              <label htmlFor="signupmodalrewards">
                {rewardsheading &&
                  <p className={css.contentHeading}>
                    {rewardsheading} I agree to the <Link to="/c/rewards-terms-of-use" target="_blank">terms and conditions</Link>
                  </p>}
                {rewardscopy && <p className={css.contentCopy}>{rewardscopy}</p>}
              </label>
            </div>
          }
          <button type="submit" className={css.btn}>
            {cta || 'Submit'}
          </button>
        </form>
      </Modal>
    );
  }
  return null;
};

SignUpModal.propTypes = {
  data: PropTypes.object,
  setSignUpModal: PropTypes.func.isRequired,
  isSignUpModalOpen: PropTypes.bool.isRequired,
  handleSignUpModalSubmit: PropTypes.func.isRequired
};

SignUpModal.contextTypes = {
  testId: PropTypes.func
};

export default SignUpModal;
